"use client";

import { cn } from "@/lib/utils/tw";
import Link from "next/link";
import Lottie from "lottie-react";
import animation from "./lottie.json";
import { useRef, useState } from "react";

interface LogoProps {
  isDarkMode?: boolean;
}

export const Logo = ({ isDarkMode = false }: LogoProps) => {
  const lottieRef = useRef<any>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLottieReady, setIsLottieReady] = useState(false);

  const handleMouseEnter = () => {
    if (!isPlaying && lottieRef.current) {
      setIsPlaying(true);
      lottieRef.current.setDirection(1);
      lottieRef.current.goToAndStop(0, true);
      lottieRef.current.play();
    }
  };

  const handleComplete = () => {
    setIsPlaying(false);
  };

  const handleLottieReady = () => {
    setIsLottieReady(true);
  };

  return (
    <Link href="/" className="group pointer-events-auto">
      <div
        className={cn(
          "flex h-7 flex-shrink-0 items-center overflow-hidden border border-transparent transition-all duration-100",
        )}
        onMouseEnter={handleMouseEnter}
      >
        <img
          src={
            isDarkMode
              ? "/logo/logotype/logo-light.svg"
              : "/logo/logotype/logo-dark.svg"
          }
          alt="Clarum"
          className="h-[20px] w-auto object-cover object-left transition-opacity group-hover:opacity-80 md:hidden"
        />

        <Lottie
          lottieRef={lottieRef}
          animationData={animation}
          className={cn(
            "hidden h-[21px] w-auto object-cover object-left transition-opacity group-hover:opacity-80 md:block",
            isDarkMode ? "invert filter" : "",
            !isLottieReady ? "hidden" : "",
          )}
          autoplay={false}
          loop={false}
          onComplete={handleComplete}
          onDOMLoaded={handleLottieReady}
        />
      </div>
    </Link>
  );
};
